// react
import React, { useState, useEffect } from 'react';

// third-party
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

// application
import Search from './Search';
import CartIndicator from './IndicatorCart';
import IndicatorAccount from './IndicatorAccount';
import { LogoSvg } from '../../svg';

function Header(props) {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 15) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={classNames('site-header site-header--hokky', { 'site-header--scrolled': isScrolled })}>
            <div className="container site-header__container hokky-header-container">
                {/* Left: Logo & Kategori */}
                <div className="hokky-header__left">
                    <Link to="/" className="hokky-header__logo" title="Hokky Bangunan - Beranda">
                        <LogoSvg />
                    </Link>
                    <Link to="/shop/category" className="hokky-header__category-btn" title="Lihat Kategori Bahan Bangunan">
                        <svg
                            className="category-icon"
                            width="18"
                            height="18"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <rect x="2" y="2" width="6.5" height="6.5" rx="2" />
                            <rect x="11.5" y="2" width="6.5" height="6.5" rx="2" />
                            <rect x="2" y="11.5" width="6.5" height="6.5" rx="2" />
                            <rect x="11.5" y="11.5" width="6.5" height="6.5" rx="2" />
                        </svg>
                        <span>Kategori</span>
                        <svg
                            className="category-arrow"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="2.5 4.5 6 8 9.5 4.5" />
                        </svg>
                    </Link>
                </div>

                {/* Center: Search Bar */}
                <div className="hokky-header__search">
                    <Search context="header" />
                </div>

                {/* Right: CS WhatsApp, Divider, Cart Indicator, Account */}
                <div className="hokky-header__right">
                    <a
                        href="https://wa.me/6281230553236?text=Halo%20Admin%20Hokky%20Bangunan,%20saya%20butuh%20bantuan"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hokky-header__cs-chip"
                        title="Customer Service WhatsApp (0812-3055-3236)"
                    >
                        <i className="fab fa-whatsapp cs-icon" />
                        <div className="cs-text">
                            <span className="cs-label">Bantuan CS</span>
                            <span className="cs-phone">0812-3055-3236</span>
                        </div>
                    </a>

                    <div className="hokky-header__divider" />

                    <div className="hokky-header__indicators">
                        <CartIndicator />
                        <IndicatorAccount />
                    </div>
                </div>
            </div>
        </div>
    );
}

Header.propTypes = {
    layout: PropTypes.oneOf(['default', 'compact']),
};

Header.defaultProps = {
    layout: 'default',
};

export default Header;

